import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import Impressumcontent from "./sections/Impressumcontent";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <Impressumcontent />
      <Footer />
    </div>;
}